var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIheartradio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iheartradio__c",
    x1: 0,
    x2: 32,
    y1: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C90025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA001F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iheartradio__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iheartradio__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iheartradio__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c12.357 0 16 3.643 16 16s-3.643 16-16 16S0 28.357 0 16 3.643 0 16 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#iheartradio__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#iheartradio__c)",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.951 6.384a7.171 7.171 0 0 0-5.932 3.211 7.193 7.193 0 0 0-5.932-3.21A7.085 7.085 0 0 0 3 13.47c0 2.487 1.566 4.268 3.21 5.933l6.422 6.07a.523.523 0 0 0 .881-.393v-4.738a2.487 2.487 0 0 1 4.973 0v4.738a.523.523 0 0 0 .881.392l6.422-6.07C27.433 17.74 29 15.959 29 13.472a7.028 7.028 0 0 0-7.049-7.087ZM9.579 18.934a.463.463 0 0 1-.372.156.531.531 0 0 1-.333-.117c-2.114-1.88-3.19-3.837-3.19-5.814v-.02A5.745 5.745 0 0 1 8.11 8.616a.497.497 0 1 1 .528.842 4.733 4.733 0 0 0-1.957 3.68v.02c0 1.684.959 3.407 2.858 5.09a.458.458 0 0 1 .04.686Zm3.172-1.82a.51.51 0 0 1-.43.254.521.521 0 0 1-.236-.06 4.714 4.714 0 0 1-2.408-3.934v-.02A3.98 3.98 0 0 1 11.79 9.85a.495.495 0 1 1 .45.88 2.984 2.984 0 0 0-1.605 2.644 3.651 3.651 0 0 0 1.9 3.074.48.48 0 0 1 .215.665Zm3.27-1.254a2.134 2.134 0 1 1 0-4.268 2.134 2.134 0 0 1 0 4.268Zm3.935 1.449a.522.522 0 0 1-.235.058.51.51 0 0 1-.431-.254.489.489 0 0 1 .196-.666 3.702 3.702 0 0 0 1.899-3.074 2.97 2.97 0 0 0-1.606-2.643.495.495 0 0 1 .45-.88 3.942 3.942 0 0 1 2.115 3.504v.02a4.61 4.61 0 0 1-2.388 3.935Zm6.382-4.15c0 1.976-1.077 3.934-3.191 5.814a.525.525 0 0 1-.705-.04.491.491 0 0 1 .039-.684c1.9-1.684 2.858-3.387 2.858-5.09v-.02a4.732 4.732 0 0 0-1.957-3.681.497.497 0 1 1 .528-.842 5.739 5.739 0 0 1 2.428 4.523v.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIheartradio);
export default __webpack_public_path__ + "static/media/iheartradio.7d9f896f6eea2b5a29982be86ca9f7d2.svg";
export { ForwardRef as ReactComponent };